import { useTranslation } from "react-i18next";
import { useStorageObject } from "../../app/state/storageObjectSlice/hook/use-storage-object";
import { useServiceNavigate } from "../../app/state/storageObjectSlice/hook/use-service-navigate";
import { Sidebar } from "../../common/AppSidebar";
import { SafeOutlet } from "../../common/Protectors/SafeOutlet";
import styles from "./styles.module.css";
import { useStorageSelectors } from "../../app/state/storageObjectSlice/hook/use-storage-selectors";

export const DialogsPage = () => {
  const { t } = useTranslation();
  const { menuItems, selectedObject, isLoading, currentService } =
    useStorageSelectors("dialogs");
  useServiceNavigate("dialogs", "dialogs");
  const { addObject, handleSelectObject } = useStorageObject(
    "dialogs",
    "dialogs",
    currentService,
  );

  return (
    <div className={styles["page-layout"]}>
      <Sidebar
        menuItems={menuItems}
        onAdd={() => addObject(t("dialogs.default_name"), "child")}
        onSelect={handleSelectObject}
        selectedId={selectedObject?.id ?? ""}
        service={"dialogs"}
        isLoading={isLoading ?? false}
      />
      {selectedObject && <SafeOutlet />}
    </div>
  );
};
